const SHOW_ERROR_ALERT = (context, payload) => {
  context.commit("SHOW_ERROR_ALERT", payload);
};

const RESET_ALERT = context => {
  context.commit("RESET_ALERT");
};

export default {
  RESET_ALERT,
  SHOW_ERROR_ALERT
};
